(function () {
  var isEnforcing = false;
  var EXCLUDED_TITLE = 'Free Unlimited Return + Package Protection Valid in US';

  function gwpItemsOf(cart) {
    return cart.items.filter(function (item) {
      return item.title.toLowerCase().includes('gwp') && item.original_price === 0;
    });
  }

  function hasQualifyingItem(cart) {
    return cart.items.some(function (item) {
      return item.original_price > 0 && item.title !== EXCLUDED_TITLE;
    });
  }

  // The cart page's own element when we're on it, otherwise the drawer's.
  function activeCartItemsEl() {
    return document.querySelector('main-cart-items')
      || document.querySelector('cart-items');
  }

  async function removeViaTheme(cartItemsEl, gwpItems) {
    for (var i = 0; i < gwpItems.length; i++) {
      var isLast = i === gwpItems.length - 1;
      await cartItemsEl.updateQuantityByKey(gwpItems[i].key, null, 0, null, isLast);
    }
  }

  async function removeViaReload(gwpItems) {
    for (var i = 0; i < gwpItems.length; i++) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: gwpItems[i].key, quantity: 0 })
      });
    }
    window.location.reload();
  }

  async function checkAndEnforceGWP() {
    if (isEnforcing) return;

    var cart;
    try {
      cart = await fetch('/cart.js').then(function (r) { return r.json(); });
    } catch (e) {
      return;
    }

    var gwpItems = gwpItemsOf(cart);
    if (gwpItems.length === 0) return;
    if (hasQualifyingItem(cart)) return;

    isEnforcing = true;
    try {
      var cartItemsEl = activeCartItemsEl();
      if (cartItemsEl && typeof cartItemsEl.updateQuantityByKey === 'function') {
        await removeViaTheme(cartItemsEl, gwpItems);
      } else {
        await removeViaReload(gwpItems);
      }
    } catch (e) {
      console.error('[gwp-cart-guard]', e);
    } finally {
      isEnforcing = false;
    }
  }

  // Re-check whenever the cart re-renders, so a gift left alone after the last
  // paid item is removed is cleared immediately instead of lingering until a reload.
  function observeCart() {
    var observer = new MutationObserver(debounce(checkAndEnforceGWP, 200));
    ['cart-drawer', 'main-cart'].forEach(function (tag) {
      var el = document.querySelector(tag);
      if (el) observer.observe(el, { childList: true, subtree: true });
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function init() {
    checkAndEnforceGWP();
    observeCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('nextsky:cart:added', checkAndEnforceGWP);
})();
